import { CommonModule } from '@angular/common';
import { Component, input, signal, effect } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IAccommodationOfferShort } from 'src/app/interfaces/interface';

@Component({
  selector: 'app-slider',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
})
export class SliderComponent {
  photos = input<string[]>();
  offer = input<IAccommodationOfferShort>();

  activePhoto = signal(0);

  constructor() {
    effect(() => {
      const list = this.photos();
      if (list && list.length > 0) {
        this.activePhoto.set(0);
      }
    });
  }

  prevPhoto() {
    const photos = this.photos();
    const current = this.activePhoto();
    this.activePhoto.set(current === 0 ? photos!.length - 1 : current - 1);
  }

  nextPhoto() {
    const photos = this.photos();
    const current = this.activePhoto();
    this.activePhoto.set(current === photos!.length - 1 ? 0 : current + 1);
  }

  setActivePhoto(i: number) {
    this.activePhoto.set(i);
  }

  getCurrentPhoto(): string {
    const list = this.photos();
    const index = this.activePhoto();
    return list?.[index] || '';
  }
}
